import { NgTemplateOutlet } from '@angular/common';
import {
  Component,
  ContentChild,
  Input,
  OnChanges,
  OnDestroy,
  TemplateRef,
  ViewChild,
  ViewEncapsulation,
  ChangeDetectionStrategy
} from '@angular/core';
import { Subject } from 'rxjs';

let nextPanelId = 0;

@Component({
  changeDetection: ChangeDetectionStrategy.OnPush,
  selector: 'm-accordion-panel',
  templateUrl: './m-accordion-panel.component.html',
  imports: [NgTemplateOutlet],
  encapsulation: ViewEncapsulation.None
})
export class MAccordionPanelComponent implements OnChanges, OnDestroy {
  @Input() value: string | number = `m-accordion-panel-${nextPanelId++}`;
  @Input() active = false;
  @Input() disabled = false;
  @Input() header?: string;
  @Input() count?: number | string | null;
  @Input() typeLabel?: string;
  @Input() alertText?: string;
  @Input() alertIcon = 'info';
  @Input() styleClass = '';

  @ContentChild('icon') iconTemplate?: TemplateRef<unknown>;

  @ViewChild('headerTpl', { static: true }) headerTpl!: TemplateRef<unknown>;

  @ViewChild('bodyTpl', { static: true }) bodyTpl!: TemplateRef<unknown>;

  // The parent m-accordion renders this panel's inputs (disabled, header, count,
  // etc.) inside its OWN template, so when a host mutates one of those inputs the
  // accordion's OnPush view must be told to re-check. The panel lives in the
  // host's CD path (it is projected content), so the panel marking itself would
  // not reach the accordion — instead it emits here and the accordion subscribes.
  readonly inputChange = new Subject<void>();

  ngOnChanges(): void {
    this.inputChange.next();
  }

  ngOnDestroy(): void {
    this.inputChange.complete();
  }

  hasCount(): boolean {
    return this.count !== undefined && this.count !== null && this.count !== '';
  }
}
